import React, { useState } from "react";

import { Routes, Route, useLocation } from "react-router-dom";
import { setLocale } from "yup";

import Home from "./pages/Home";
import SignUp from "./pages/auth/Signup";
import VerifyAccount from "./pages/auth/VerifyAccount";
import Login from "./pages/auth/Login";
import Header from "./components/Header";
import DownNavBar from "./components/DownNavBar";
import AfterSignup from "./pages/auth/AfterSignup";
import PrivateRoute from "./PrivateRoute";
import RequireAuth from "./hooks/RequireAuth";
import RequestResetPassword from "./pages/auth/RequestResetPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import SuccessPayment from "./pages/successPayment";
import FailedPayment from "./pages/FailedPayment";
import AddNewPost from "./pages/AddNewPost";
import AboutUs from "./pages/AboutUs";
import Contact from "./pages/Contact";
import PethubApp from "./pages/PethubApp";
import AdPost from "./pages/AdPost";
import Search from "./pages/Search";
import SinglePost from "./pages/SinglePost";
import ActivePosts from "./pages/ActivePosts";
import Footrer from "./components/Footer";
import Profile from "./pages/Profile";
import Favorite from "./pages/Favorite";
import Messages from "./pages/Messages";
import ScrollToTop from "./components/ScrollToTop";
import QR from "./pages/QR";
import FindPet from "./pages/FindPet";
import Rules from "./pages/Rules";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ReturnPolicy from "./pages/ReturnPolicy";
import Workers from "./pages/Workers";
import OrderQRCollarPage from "./pages/OrderQRCollarPage";
import GenerateQR from "./pages/GenerateQR";
import UpdatePost from "./pages/UpdatePost";
import NotFound from "./pages/NotFound";
import Checkout from "./pages/Checkout";
import SettingsPage from "./pages/SettingsPageForMobile";
import { ToastContainer } from "react-toastify";
import GlobalCart from "./components/GlobalCart";
import InstallPrompt from "./components/InstallPrompt";
import UserPanelPage from "./pages/UserPanelForMobile";
import SkeletonLoader from "./components/SkeletonLoader";

import "react-toastify/dist/ReactToastify.css";

import "./styles/styles.scss";
import "./styles/aboutus.scss";
import "./styles/contact.scss";
import "./styles/pethubapp.scss";
import "./styles/userpanel.scss";
import "./styles/resolution.scss";
import "./styles/seemore.scss";
import "./styles/darkmode.scss";
import "./styles/loading.scss";
import "./styles/orderpage.scss";
import "./styles/checkout.scss";
import "./styles/skeletons.scss";
import "./styles/pinonmap.scss";
import "./styles/community.scss";

import "leaflet/dist/leaflet.css";

import "swiper/css";
import "swiper/css/grid";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import "swiper/css/effect-coverflow";
import "swiper/css/effect-fade";

const App = () => {
  const [darkMode, setDarkMode] = useState(localStorage.getItem("dark-mode"));
  const location = useLocation();
  setLocale({
    mixed: {
      required: ({ required }) => ({
        key: "required_field",
        values: { required },
      }),
      notType: function notType(_ref) {
        switch (_ref.type) {
          case "number":
            return "number_type_error";
          case "string":
            return "Not a string error or any other custom error message";
          default:
            return "Wrong type error or any other custom error message";
        }
      },
    },
    string: {
      email: ({ email }) => ({ key: "invalid_email", values: { email } }),
    },
    number: {
      integer: "Input should be only numbers",
      positive: "Please type only positive numbers.",
      max: ({ max }) => ({ key: "field_too_big", values: { max } }),
    },
  });

  return (
    <div className={darkMode}>
      <InstallPrompt />
      <ScrollToTop />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {location.pathname.slice(0, 6) !== "/find/" ? (
        <>
          <Header setDarkMode={setDarkMode} darkMode={darkMode} />
          <DownNavBar darkMode={darkMode} />
        </>
      ) : (
        <></>
      )}
      <Routes>
        <Route path="/" element={<Home darkMode={darkMode} />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/rules" element={<Rules />} />
        <Route
          path="/settingsPage"
          element={
            <SettingsPage setDarkMode={setDarkMode} darkMode={darkMode} />
          }
        />
        <Route path="/UserPanelPage" element={<UserPanelPage />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/returnpolicy" element={<ReturnPolicy />} />
        <Route path="/ad/posts/:postType" element={<AdPost />} />
        <Route path="/pethubapp" element={<PethubApp />} />
        <Route path="/search" element={<Search />} />
        <Route path="/post/:postID" element={<SinglePost />} />
        <Route path="/success/payment" element={<SuccessPayment />} />
        <Route path="/failed/payment" element={<FailedPayment />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verify/:uid64/:token" element={<VerifyAccount />} />
        <Route path="/after/signup/" element={<AfterSignup />} />
        <Route path="/qrcollar" element={<QR />} />
        <Route path="/workers" element={<Workers />} />
        <Route path="/find/:qrID" element={<FindPet darkMode={darkMode} />} />
        <Route
          path="/request/reset/password"
          element={<RequestResetPassword />}
        />
        <Route
          path="/reset/password/:uid64/:token"
          element={<ResetPassword />}
        />
        <Route
          path="/add/new/post"
          element={
            <RequireAuth>
              <AddNewPost />
            </RequireAuth>
          }
        />
        <Route path="/generateqr" element={<GenerateQR />} />
        <Route
          path="/me"
          element={
            <RequireAuth>
              <Profile />
            </RequireAuth>
          }
        />
        <Route
          path="/active/posts"
          element={
            <RequireAuth>
              <ActivePosts />
            </RequireAuth>
          }
        />
        <Route
          path="/favorite"
          element={
            <RequireAuth>
              <Favorite />
            </RequireAuth>
          }
        />
        <Route
          path="/messages"
          element={
            <RequireAuth>
              <Messages />
            </RequireAuth>
          }
        />

        <Route path="/order/qrcollar" element={<OrderQRCollarPage />} />
        <Route
          path="/order/gpstracker"
          element={<OrderQRCollarPage productType="gps-tracker" />}
        />
        <Route
          path="/update/post/:postID"
          element={
            <RequireAuth>
              <UpdatePost />
            </RequireAuth>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {location.pathname.slice(0, 6) !== "/find/" ? <Footrer /> : <></>}
      {/* <GlobalCart /> */}
    </div>
  );
};

export default App;
